/*
 * Copyright (c) 2023 Irian Software Development SRL. All Rights Reserved.
 * This software is the proprietary information of Irian Software Development SRL.
 * Use is subject to license and non-disclosure terms
 */

import { Injectable, inject } from '@angular/core';
import {Client} from '@stomp/stompjs';
import {ReplaySubject, Subscription} from 'rxjs';
import Configuration from './Configuration';
import {LocalStorageService, SessionStorageService} from 'ngx-webstorage';

@Injectable()
export class StompService {
  private config = inject<Configuration>('config' as any);
  private $localStorage = inject(LocalStorageService);
  private $sessionStorage = inject(SessionStorageService);

  stompCallbacks: ReplaySubject<any> = new ReplaySubject();
  stompCallbacksSubscription: Subscription | undefined = undefined;

  stompClient: Client | undefined = undefined;

  initializeWebSocketConnection(serverUrl: string = this.config.serverUrl as string) {
    const token = this.$localStorage.retrieve('authenticationToken') || this.$sessionStorage.retrieve('authenticationToken');
    this.stompClient = new Client({
      brokerURL: `${serverUrl.replace(/^http/, 'ws')}`,
      connectHeaders: {Authorization: `Bearer ${token}`},
      debug: () => {return;},
      reconnectDelay: 0,
    });

    this.stompClient.onConnect = () => {
      this.stompCallbacksSubscription = this.stompCallbacks.subscribe(
        callback => {
          callback(this.stompClient);
        }
      );
    };

    this.stompClient.activate();
  }

  disconnect() {
    if(this.stompCallbacksSubscription && this.stompClient) {
      if (!this.stompCallbacksSubscription.closed) {
        try {
          this.stompClient.deactivate().then(() => {
            this.stompCallbacksSubscription?.unsubscribe();
            this.stompCallbacks = new ReplaySubject();
          });
        } catch (e) {
          console.error(e);
        }
      }
    }
  }

  register(callback: any) {
    this.stompCallbacks.next(callback);
  }

  send(topicUrl: string, data: any){
    this.stompClient?.publish({destination: topicUrl, body: JSON.stringify(data)});
  }

  sendRaw(topicUrl: string, data: any){
    this.stompClient?.publish({destination: topicUrl, body: data});
  }

}

